import React from "react";
import "./SiteHeader.css";
import useAuthStore from "../../stores/authStore";
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { FiHome, FiVideo, FiLogIn, FiUserPlus, FiLogOut, FiSettings, FiShield, FiUserCheck } from "react-icons/fi";

const SiteHeader = ({ mode = 'light' }) => {
    const user = useAuthStore(state => state.user);
    const role = useAuthStore(state => state.role);
    const logout = useAuthStore(state => state.logout);
    const navigate = useNavigate();
    const isAdmin = role === 'admin';
    const getNavLinkClassName = ({ isActive }) => `nav-link${isActive ? ' nav-link--active' : ''}`;

    return (
        <header className={`site-header ${mode}${user ? ' site-header--authenticated' : ''}`}>
            <div className="header-container">
                <Link className="header-brand" to="/">
                    <h1 className="logo-text">Ting Vision</h1>
                </Link>

                <nav className="header-nav" aria-label="Main navigation">
                    {user && (
                        <div className="nav-links">
                            <NavLink
                                to="/"
                                end
                                className={getNavLinkClassName}
                            >
                                <FiHome className="nav-icon" aria-hidden="true" />
                                <span>Home</span>
                            </NavLink>
                            <NavLink
                                to="/sightings"
                                className={getNavLinkClassName}
                            >
                                <FiVideo className="nav-icon" aria-hidden="true" />
                                <span>Sightings</span>
                            </NavLink>
                            <NavLink
                                to="/settings"
                                className={getNavLinkClassName}
                            >
                                <FiSettings className="nav-icon" aria-hidden="true" />
                                <span>Settings</span>
                            </NavLink>
                            {isAdmin && (
                                <NavLink to="/admin/community-reviews" aria-label="Community reviews" className={getNavLinkClassName}>
                                    <FiShield className="nav-icon" aria-hidden="true" />
                                    <span className="nav-label-desktop">Community reviews</span>
                                    <span className="nav-label-mobile" aria-hidden="true">Reviews</span>
                                </NavLink>
                            )}
                            {isAdmin && (
                                <NavLink
                                    to="/admin"
                                    end
                                    className={getNavLinkClassName}
                                >
                                    <FiUserCheck className="nav-icon" aria-hidden="true" />
                                    <span>Admin</span>
                                </NavLink>
                            )}
                        </div>
                    )}

                    <div className="nav-actions">
                        {user ? (
                            <button 
                                className="auth-button logout"
                                onClick={(e) => {
                                    logout(e);
                                    navigate('/login');
                                }}
                            >
                                <FiLogOut className="auth-icon" aria-hidden="true" />
                                <span>Logout</span>
                            </button>
                        ) : (
                            <>
                                <Link
                                    to="/login"
                                    className="auth-button login"
                                >
                                    <FiLogIn className="auth-icon" aria-hidden="true" />
                                    <span>Login</span>
                                </Link>
                                <Link
                                    to="/register"
                                    className="auth-button signup"
                                >
                                    <FiUserPlus className="auth-icon" aria-hidden="true" />
                                    <span>Sign Up</span>
                                </Link>
                            </>
                        )}
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default SiteHeader;
